/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-return-assign */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';

import { formatNumber } from '../../utilities/formatHelpers';
import { exchange } from '../../utilities/constants';
import CurrencyIcon from '../CurrencyIcon';
import { dynamicAssets } from '../../utilities/helpers';

const { Option } = components;
export const CustomSelectOption = (props) => (
  <Option {...props}>
    <div className="flex-row-center px-2">
      <CurrencyIcon currencyCode={props.data.coin} className="m-0" />
      <p className="m-0 text-f5">{props.data.coin}</p>
    </div>
  </Option>
);
CustomSelectOption.propTypes = {
  data: PropTypes.object.isRequired,
};

export const CustomSelectValue = (props) => (
  <div className="flex-row-center">
    <CurrencyIcon
      currencyCode={props.data.coin}
      className="me-2"
      style={{ width: '1.4rem', height: '1.4rem' }}
    />
    <p className="m-0 text-f5">{props.data.coin}</p>
  </div>
);

CustomSelectValue.propTypes = {
  data: PropTypes.object.isRequired,
};

export const Logo = (props) => (
  <div className="">
    <img
      {...props}
      style={{ width: '14rem', height: 'auto' }}
      className="logo mb-1"
      src={dynamicAssets('./assets/images/logo.svg')}
      alt="Logo"
    />
  </div>
);
export const LogoHeader = (props) => (
  <div className="">
    <img
      {...props}
      style={{ width: '6rem', height: 'auto' }}
      className="logo mb-1"
      src={dynamicAssets('./assets/images/logo.svg')}
      alt="Logo"
    />
  </div>
);

export const CustomCountryCodeSelectValue = ({ children, flag }) => (
  <div className="flex-row-center h-100">
    {flag && (
      <img
        className="rounded-circle me-2"
        src={dynamicAssets(`./assets/images/flags/1x1/${flag}.svg`)}
        alt={flag}
        style={{ width: '1rem' }}
      />
    )}
    {children}
  </div>
);
CustomCountryCodeSelectValue.propTypes = {
  children: PropTypes.any.isRequired,
  flag: PropTypes.string.isRequired,
};

export const CustomFormatOptionLabel = ({ optionName, iso3166alpha2, prefix, ...props }) => (
  <div className="justify-content-center h-100">
    {iso3166alpha2 && (
      <img
        className="rounded-circle me-2"
        src={dynamicAssets(`./assets/images/flags/1x1/${iso3166alpha2}.svg`)}
        alt={iso3166alpha2}
        style={{ width: '1rem' }}
      />
    )}
    {prefix}
    {props[optionName]}
  </div>
);
CustomFormatOptionLabel.propTypes = {
  optionName: PropTypes.string.isRequired,
  iso3166alpha2: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
};

export const PercentageBadge = ({ percentage, background }) => (
  <span
    className={`${percentage > 0 && 'bg-success-light text-success'} ${
      percentage < 0 && 'bg-danger-light'
    } ${
      percentage === 0 || (isNaN(percentage) && background)
    } rounded-3 text-center text-f6 px-2 py-1 flex-row-center`}
    style={{
      minWidth: '3.188rem',
    }}>
    {!isNaN(percentage) && (
      <i
        className={`text-f6 icon icon-Polygon-1 me-1 ${percentage > 0 && 'text-success'} ${
          percentage < 0 && 'text-danger'
        } ${percentage === 0 || (isNaN(percentage) && 'text-light')} ${
          percentage > 0 ? '' : 'rotate-180'
        }`}
      />
    )}
    <b className="w-100">{`${formatNumber(Math.abs(percentage), exchange.FIAT_VALUE)}%`}</b>
  </span>
);

PercentageBadge.propTypes = {
  percentage: PropTypes.number.isRequired,
  background: PropTypes.string,
};

PercentageBadge.defaultProps = {
  background: 'bg-light',
};

export const MenuIcon = () => (
  <i className="icon position-relative icon-settings-menu text-f3 text-shadow rotate-90 cursor-pointer" />
);
